var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3B5998",
    fillRule: "evenodd",
    d: "M22.675.5H1.325C.593.5 0 1.093 0 1.825v21.35c0 .732.593 1.325 1.325 1.325h11.494v-9.294H9.691v-3.622h3.128V8.913c0-3.1 1.893-4.788 4.659-4.788 1.324 0 2.463.098 2.795.143v3.24h-1.918c-1.504 0-1.795.715-1.795 1.763v2.313h3.586l-.467 3.622h-3.12V24.5h6.116c.732 0 1.325-.593 1.325-1.325V1.825C24 1.093 23.407.5 22.675.5"
  })));
};
export default SvgFacebook;